import React, { useContext, useEffect, useState } from "react";
import { Typography } from "antd";
import { ReportTable } from "../components/ReportTable";
import { FormatButtons, FormatConfig } from "../components/FormatButtons";
import { useAllFinancialDataHook } from "../../../../../../hooks/useFetchFinancialData.hook";
import { StateContext } from "../../../../../../store/context";

const { Title } = Typography;

interface IncomeStatementProps {
  selectedStock?: any;
}

export const IncomeStatement: React.FC<IncomeStatementProps> = ({
  selectedStock,
}) => {
  const { baseCurrency } = useContext(StateContext);
  const [formatConfig, setFormatConfig] = useState<FormatConfig>({
    decimal: "decimal_00",
    scale: "millions",
  });
  const [hasDecimalBeenModified, setHasDecimalBeenModified] = useState(false);

  const handleFormatChange = (config: FormatConfig) => {
    if (config.decimal !== formatConfig.decimal) {
      setHasDecimalBeenModified(true);
    }
    setFormatConfig(config);
  };

  const stockId = selectedStock?.id || selectedStock?.stock_id;

  const queryParams = new URLSearchParams({
    stock_id: String(stockId),
    isQuarterly: "false",
    baseCurrency: baseCurrency || "LKR",
    reportType: "1",
    selectedPeriod: "5",
    reverseDate: "false",
    showMargins: "true",
  }).toString();

  const { data, isLoading } = useAllFinancialDataHook(
    stockId ? queryParams : null,
  );

  return (
    <div className="vi-glass-card p-6">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <Title level={5} style={{ margin: 0 }}>
          Income Statement
        </Title>
        <FormatButtons
          formatConfig={formatConfig}
          onFormatChange={handleFormatChange}
        />
      </div>
      <ReportTable
        data={stockId ? data : null}
        viewMode="annually"
        loading={isLoading}
        formatConfig={formatConfig}
        hasDecimalBeenModified={hasDecimalBeenModified}
      />
    </div>
  );
};
